import script from "./SubastaPortada.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastaPortada.vue?vue&type=script&setup=true&lang=js"

import "./SubastaPortada.vue?vue&type=style&index=0&id=2ee9c9f3&lang=css"

const __exports__ = script;

export default __exports__